import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Site, SiteService } from '@flyfreely-portal-ui/flyfreely';
import { WorkspaceStateService } from '@flyfreely-portal-ui/workspace';
import {
    combineLatest,
    map,
    Observable,
    shareReplay,
    startWith,
    switchMap
} from 'rxjs';

/**
 * A scoped data service that allows shared, up to date handling of site lists.
 */
@Injectable()
export class SitesDataService {
    sites$: Observable<{ siteList: Site[]; organisationId: number }>;

    constructor(
        siteService: SiteService,
        workspaceStateService: WorkspaceStateService
    ) {
        this.sites$ = combineLatest([
            workspaceStateService.currentLoadedOrganisation$,
            siteService.change$.pipe(startWith(undefined))
        ]).pipe(
            switchMap(([o, _]) =>
                siteService
                    .findSites(o.organisation.id, o.organisation.id, true)
                    .pipe(
                        map(siteList => ({
                            siteList,
                            organisationId: o.organisation.id
                        }))
                    )
            ),
            shareReplay(),
            takeUntilDestroyed()
        );
    }
}
